// extracted by mini-css-extract-plugin
module.exports = {"tag":"story-tags-module__tag__2JnHJ"};